import { composeReducers } from 'complionUtil';
import lodash from 'lodash';

import {
    LOAD_STUDY_DELEGATIONS_V2,
    ADD_STUDY_DELEGATION_V2,
    DELETE_STUDY_DELEGATION_V2,
    UPDATE_STUDY_DELEGATION_V2,
    UNLOAD_STUDY_TASKS_AND_DELEGATIONS_V2
} from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';

const KEYS_TO_FILTER_ON_UNLOAD = ['doaStudyTasks', 'doaStudyDelegations', 'users', 'doaTestaments'];

export function loadStudyDelegations(state, action) {
    if (action && action.type === 'LOADING_DELEGATIONS') {
        return {
            ...state,
            app: {
                ...state.app,
                loadingStudyDelegations: true,
                loadingStudySignatures: true,
            }
        };
    }
    if (!action || action.type !== LOAD_STUDY_DELEGATIONS_V2) {
        return state;
    }
    const studyDelegations = action.payload;

    return {
        ...state,
        doaStudyDelegations: studyDelegations,
        app: {
            ...state.app,
            loadingStudyDelegations: false,
        }
    };
}

export function addStudyDelegation(state, action) {
    if (action && action.type === 'UPSERT_DELEGATION_BEGIN') {
        return {
            ...state,
            app: {
                ...state.app,
                upsertDelegationRequesting: true,
            }
        };
    }

    if (action && action.type === 'UPSERT_DELEGATION_END') {
        return {
            ...state,
            app: {
                ...state.app,
                upsertDelegationRequesting: false,
            }
        };
    }

    if (!action || action.type !== ADD_STUDY_DELEGATION_V2) {
        return state;
    }

    const newStudyDelegations = action.payload;
    if (lodash.isNil(newStudyDelegations) || lodash.isEmpty(newStudyDelegations)) {
        return state;
    }

    const { doaStudyDelegations } = state;
    const updatedUserDelegations = doaStudyDelegations.concat(newStudyDelegations);

    return {
        ...state,
        doaStudyDelegations: updatedUserDelegations,
    };
}


export function deleteStudyDelegationV2(state, action) {
    if (!action || action.type !== DELETE_STUDY_DELEGATION_V2) {
        return state;
    }

    const delegationsBeforeDeletion = state.doaStudyDelegations;
    const delegationDeletedId = lodash.get(action, 'payload.deleteStudyDelegationV2.id', null);

    const remainingDoaStudyDelegations = lodash.reject(delegationsBeforeDeletion, delegation => {
        return delegation.id === delegationDeletedId;
    });

    return {
        ...state,
        doaStudyDelegations: remainingDoaStudyDelegations,
    };
}


export function updateStudyDelegation(state, action) {
    if (!action || action.type !== UPDATE_STUDY_DELEGATION_V2) {
        return state;
    }

    let updatedDelegation = action.payload;
    if (lodash.isNil(updatedDelegation)) {
        return state;
    }

    const updatedDelegations = state.doaStudyDelegations;
    const outdatedDelegationIndex = updatedDelegations.findIndex(delegation => delegation.id === updatedDelegation.id);
    const outdatedDelegation = state.doaStudyDelegations[outdatedDelegationIndex];

    if (outdatedDelegation && outdatedDelegation.signatures) {
        updatedDelegation.signatures = outdatedDelegation.signatures;
    }

    updatedDelegations[outdatedDelegationIndex] = updatedDelegation;

    return {
        ...state,
        doaStudyDelegations: updatedDelegations,
    };
}

export function unloadStudyTasksAndDelegations(state, action) {
    if (!action || action.type !== UNLOAD_STUDY_TASKS_AND_DELEGATIONS_V2) {
        return state;
    }

    return lodash.pickBy(state, (value, key) => !KEYS_TO_FILTER_ON_UNLOAD.includes(key));
}

export default composeReducers(
    loadStudyDelegations,
    addStudyDelegation,
    deleteStudyDelegationV2,
    updateStudyDelegation,
    unloadStudyTasksAndDelegations,
);
